import { useParams } from "react-router-dom";
import GenericLesson from "@/lessons/GenericLesson";
import SightReadingLesson from "./SightReadingLesson";

/**
 * Dispatches /lesson/:slug to the right renderer.
 *
 * React Router does not support a param inside part of a path segment, so a
 * route of "/lesson/sight-reading-:n" never matches — "/lesson/:slug" swallows
 * it and every Sight Reading piece falls through to the generic lesson page.
 * The prefix therefore has to be tested here, inside a route that does match.
 */
export default function LessonRouter() {
  const { slug = "" } = useParams<{ slug: string }>();
  if (slug.startsWith("sight-reading-")) return <SightReadingLesson />;
  return <GenericLesson />;
}
